import { Box, styled } from '@mui/system';
import discord from '../../assets/icons/discord.png';
import ig from '../../assets/icons/ig.png';
import medium from '../../assets/icons/medium.png';
import poodle from '../../assets/icons/poodle_head.png';
import twitter from '../../assets/icons/twitter.png';

const links = [
  {
    icon: poodle,
    link: `https://poodlnft.art`,
  },
  {
    icon: discord,
    link: 'https://discord.gg/Rj8C4ZDUbP',
  },
  {
    icon: twitter,
    link: 'https://twitter.com/Mardy_NFT',
  },
  {
    icon: ig,
    link: 'https://instagram.com/mardy_nft',
  },
  {
    icon: medium,
    link: 'https://medium.com/@MARDY_NFT',
  },
];

export const SocialLinks = () => {
  return (
    <Root>
      <LinksContainer>
        {links.map((link) => (
          <a href={link.link} target='_blank' key={link.link}>
            <img src={link.icon} alt='icon' />
          </a>
        ))}
      </LinksContainer>
    </Root>
  );
};

const Root = styled(Box)({
  width: '100%',
  zIndex: 1,
  position: 'absolute',
  bottom: 0,
  background: '#45985e',
  padding: '10px 0',
});
const LinksContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: '10px',
  paddingLeft: '20px',

  '& img': {
    maxWidth: '55px',
  },
});
